export default __webpack_public_path__ + "static/media/icon-Lyra_full.808bb11b.svg";